import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute,Router  } from '@angular/router';
import { Location } from '@angular/common';
import { CommonService } from '../service/common.service';
import { QuestionService } from '../service/question.service';
import { UsersService } from '../service/users.service';
import { Role } from '../app.constant';

@Component({
    selector: 'question-register-app',
      templateUrl: './question-register.component.html',
      styleUrls: ['question-register.component.css']
    })

export class QuestionRegisterComponent {
    @Input() qid: number;
    isLoaded : boolean = false;
    selected_question_id : number = null;
    selected_question_category_id : number = null;
    selected_language_id : number = null;
    selected_result_option : number = null;

    nextflg:boolean;
    ROLE: any = Role;
    
    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private commonService: CommonService,
        private questionService: QuestionService,
        public usersService: UsersService,
        private location: Location,
    ) { }
    input_tilte_info : any={
        placeholder: "表示名を入力してください",
        support: "表示名を入力してください",
        minlength: 1,
        maxlength: 64,
    }
    input_question_info : any={
        placeholder: "問診の内容を入力してください",
        support: "問診の内容を入力してください",
        minlength: 1,
        maxlength: 256,
    }
    input_errmsg_info : any={
        placeholder: "エラーメッセージを入力してください",
        support: "回答欄が空白時、表示するエラーメッセージを入力してください。",
        minlength: 1,
        maxlength: 64
      }

    result_option={
        option_list:[
            {values:'1',name:"対象者選択として登録する", disabled:false,
                support:"絞込をしたい条件として登録します。<br>登録例：<br>　表示名：年代<br>　質問内容：年代を選択してください<br>　選択肢：10代、20代、30代・・・"},
            {values:'2',name:"タイトルとして登録する", disabled:false,
                support:"問診票の途中にタイトルを挿入します。<br>質問をグループとして見せたいときなどに利用します。<br>登録例：<br>　<b>あなたの生活状況について教えてください　※</b><br>　通勤手段についての質問<br>　生活環境についての質問<br><b>※</b>のようにタイトルとして挿入したい時に"},
            {values:'0',name:"通常の質問として登録する", disabled:false,
                support:"問診票の質問を登録します。<br>登録例：<br>　質問内容：体調はいいですか？<br>　選択肢：良い、普通、悪い・・・"},
        ]
    };
    
    questiontype_list_info:any={
        label:'回答タイプ選択',
        support:'タイプを選択してください',
        selectlist : []
    };
    answertype_list_info:any={
        label:'回答種類',
        support:'入力させる値が、数値型であるかを設定してください',
        selectlist : []
    };
    answer_list_info:any={
        'label':'回答選択肢登録',
        'support':'回答選択肢を登録してください',
        'answerlist' : [
            //ここに回答リストが入る
        ],
        'nextquestionlist':{
            //ここに２次質問として選択していいリストが入る
        },
        'nextflg':false,
        'addflg':false,
        'errorflg':false
    };

    target_list_info:any= {
            label:"対象者選択",
            support:'対象者を選択してください',
            selectlist :[]
            };
    question_caterogy_info : any={};
    question : any={};
    
    answer : any={};
    
    targetlist :any;
    chemicalsubstancelist :any;
    organicsolventlist :any;
    previousspeventlist :any;

    ngOnInit(): void {
        this.selected_question_category_id= +this.route.snapshot.paramMap.get('qcid');
        this.selected_question_id  = +this.route.snapshot.paramMap.get('qid');
        this.selected_language_id = +this.route.snapshot.paramMap.get('lid');
        this.selected_result_option = +this.route.snapshot.paramMap.get('ro');
    
        this.question.code='・・・';
        this.question_caterogy_info.language_name='・・・';
        this.isLoaded = false;

        this.getList();

        //画面上部へ移動
        window.scrollTo(0, 0);

    }

    getList(): void {
        //初期化
        this.all_chemicalsubstancelist_flg = false;
        this.all_organicsolventlist_flg = false;

        this.questionService.getQuestion(
            this.selected_question_category_id,
            this.selected_question_id,
            this.selected_language_id
            )
        .subscribe((res: Response) => {
            if (res["fuel_status"] == "OK") {
                if (this.selected_question_id==0){
                    //新規の処理
                    this.question_caterogy_info= res["fuel_results"]['question_caterogy_info'][0];
                    this.questiontype_list_info["selectlist"] = res["fuel_results"]['questiontypelist'];
                    this.answertype_list_info["selectlist"] = res["fuel_results"]['answertypelist'];
                    this.target_list_info["selectlist"]= res["fuel_results"]['targetlist'];
                    this.targetlist =  res["fuel_results"]['targetlist'];
                    this.chemicalsubstancelist= res["fuel_results"]['chemicalsubstancelist'];
                    for (let i = 0; i < this.chemicalsubstancelist.length; i++) {
                        this.chemicalsubstancelist[i]['selected'] = this.commonService.exchange01toTF(this.chemicalsubstancelist[i]['selected']);
                    }  
                    this.organicsolventlist= res["fuel_results"]['organicsolventlist'];
                    for (let i = 0; i < this.organicsolventlist.length; i++) {
                        this.organicsolventlist[i]['selected'] = this.commonService.exchange01toTF(this.organicsolventlist[i]['selected']);
                    }
  
                    this.previousspeventlist= res["fuel_results"]['previousspeventlist'];
                    this.question= {
                        "id": null,
                        "m_question_category_id": this.selected_question_category_id,
                        "m_question_type_id": this.selected_result_option == 2 ? "0":"1",
                        "m_question_type_id_old":0,
                        "m_answer_type_id": 1,
                        "code": "新規",
                        "required_flg": this.selected_result_option == 1 ? true:false,
                        "last_text_input_flg": false,
                        "last_text_input_include_flg": false,
                        "last_text_input_required_flg":false,
                        "result_option":  this.selected_result_option,
                        "previous_answer_t_question_category_id":null,
                        "question_title": "",
                        "question_text": "",
                        "required_msg": null,
                        "last_text_input_required_msg": null,
                        "prefix_label" : "",
                        "suffix_label" : "",
                        "update_datetime": null,
                        "update_datetime_q": null,
                        "update_datetime_qc": null,
                        "target": []
                    };
                    this.answer_list_info["answerlist"]=[
                        {
                            "m_answer_id": null,
                            "m_answer_content_id":null,
                            "answer_code": null,
                            "m_substance_id":null,
                            "hidden_flg":false,
                            "answer_text": "",
                            "next_question_list": []
                          },
                          {
                            "m_answer_id": null,
                            "m_answer_content_id":null,
                            "answer_code": null,
                            "m_substance_id":null,
                            "hidden_flg":false,
                            "answer_text": "",
                            "next_question_list": []
                          }
                    ];
                    this.answer_list_info["nextquestionlist"]= res["fuel_results"]['nextquestionlist'];
                    this.answer_list_info.addflg = false;    
                }else{
                    //先頭の言語表示
                    this.question_caterogy_info= res["fuel_results"]['question_caterogy_info'][0];
                    //質問の内容
                    if (res["fuel_results"]['question'].length==0){
                        //対象の問診がないメッセージを表示し、一覧画面へ飛ばす
                        this.commonService.modalOpens(11008,modalresult=>{
                            this.router.navigate(["/question-list/" + this.selected_question_category_id + "/" + this.selected_language_id]);
                            });
                    }else{
                        this.question= res["fuel_results"]['question'][0];
                        //回答タイプ
                        this.questiontype_list_info["selectlist"]= res["fuel_results"]['questiontypelist'];
                        this.answertype_list_info["selectlist"] = res["fuel_results"]['answertypelist'];
                        //回答内容
                        this.answer_list_info["answerlist"]= res["fuel_results"]['answerlist'];
                        for (let i = 0; i < this.answer_list_info["answerlist"].length; i++) {
                            this.answer_list_info["answerlist"][i]['hidden_flg'] = this.commonService.exchange01toTF(this.answer_list_info["answerlist"][i]['hidden_flg']);
                        }  

                        //回答に紐づける２次質問
                        this.answer_list_info["nextquestionlist"]= res["fuel_results"]['nextquestionlist'];
                        //対象者選択情報
                        this.target_list_info["selectlist"]= res["fuel_results"]['targetlist'];
                        this.targetlist =  res["fuel_results"]['targetlist'];

                        //特健情報
                        this.chemicalsubstancelist= res["fuel_results"]['chemicalsubstancelist'];
                        for (let i = 0; i < this.chemicalsubstancelist.length; i++) {
                            this.chemicalsubstancelist[i]['selected'] = this.commonService.exchange01toTF(this.chemicalsubstancelist[i]['selected']);
                        }  
                        this.organicsolventlist= res["fuel_results"]['organicsolventlist'];
                        for (let i = 0; i < this.organicsolventlist.length; i++) {
                            this.organicsolventlist[i]['selected'] = this.commonService.exchange01toTF(this.organicsolventlist[i]['selected']);
                        }
                        this.previousspeventlist= res["fuel_results"]['previousspeventlist'];

                        //回答が空だった場合、暫定で空リストを作成
                        if (this.answer_list_info["answerlist"].length==0){
                            this.answer_list_info["answerlist"]=[
                                {
                                    "m_answer_id": null,
                                    "m_answer_content_id":null,
                                    "answer_code": null,
                                    "m_substance_id":null,
                                    "hidden_flg":false,
                                    "answer_text": "",
                                    "next_question_list": []
                                },
                                {
                                    "m_answer_id": null,
                                    "m_answer_content_id":null,
                                    "answer_code": null,
                                    "m_substance_id":null,
                                    "hidden_flg":false,
                                    "answer_text": "",
                                    "next_question_list": []
                                }
                            ];
            
                        }
                        if(this.question.m_question_type_id==6 || this.question.m_question_type_id==7){
                            this.answer_list_info.addflg = true;
                        }else{
                            this.answer_list_info.addflg = false;

                        }
                        //01→TF変換
                        this.question.required_flg = this.commonService.exchange01toTF(this.question.required_flg);
                        this.question.last_text_input_flg = this.commonService.exchange01toTF(this.question.last_text_input_flg);
                        this.question.last_text_input_include_flg = this.commonService.exchange01toTF(this.question.last_text_input_include_flg);
                        this.question.last_text_input_required_flg = this.commonService.exchange01toTF(this.question.last_text_input_required_flg);
                    }
                }
                this.checkNextFlg();
                this.isLoaded = true;
            }else if (res["fuel_status"] == "NG") {
                this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
            }else{
                this.commonService.modalOpens(11003,modalresult=>{});
            }
        }, error => {
            this.commonService.modalOpens(error,modalresult=>{});
        });
    }



    checkNextFlg():void{
        if(this.question.result_option=="0"){

            //通常質問の時
            if(this.answer_list_info["nextquestionlist"].length==0){
                //２次質問リストが空の時　不可
                this.answer_list_info.nextflg = true;
            }else{
                //２次質問リストが１件以上ある時　可
                this.answer_list_info.nextflg = false;
            }
        }else if(this.question.result_option=="1"){
            //対象者情報の時　不可
            this.answer_list_info.nextflg =  true;
        }else{
            //不可
            this.answer_list_info.nextflg =  false;
        }
    }
    changePreviousSPEvent(){
        var row = this.previousspeventlist.filter(
            item => 
            item.t_question_category_id==this.question.previous_answer_t_question_category_id
            );
        ;
        this.question.question_title = row[0]['m_question_type_names'];
        this.question.question_text = row[0]['t_event_name']+"："+row[0]['m_qusetion_category_name']+"（"+row[0]['m_question_type_names']+"）";
    }
    changeType(){
        if(this.question.m_question_type_id_old!=10 && this.question.m_question_type_id==10){
            this.question.m_answer_type_id = 2;
        }else if(this.question.m_question_type_id==6 || this.question.m_question_type_id==7){
            this.question.required_flg = true;
            this.answer_list_info.nextflg = true;
            this.answer_list_info.addflg = true;
            this.questionService.getSpecialCheckUPList(this.question.m_question_type_id)
            .subscribe((res: Response) => {
                if (res["fuel_status"] == "OK") {
                    var splist = res["fuel_results"];
                    this.answer_list_info["answerlist"]=[];
                        for(var i in splist){
                        this.answer_list_info["answerlist"].push(
                            {
                                "m_answer_id": null,
                                "m_answer_content_id": null,
                                "answer_code": splist[i]['answer_code'],
                                "m_substance_id":splist[i]['m_substance_id'],
                                "answer_text": splist[i]['answer_text'],
                                "hidden_flg":false,
                                "update_datetime": null,
                                "next_question_list": []
                            });
                    }
                }else if (res["fuel_status"] == "NG") {
                    this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                }else{
                    this.commonService.modalOpens(11003,modalresult=>{});
                }
            }, error => {
                this.commonService.modalOpens(error,modalresult=>{});
            });
        }else{
            this.answer_list_info.nextflg = false;
            this.answer_list_info.addflg = false;
        }
        this.checkNextFlg();

    }
    all_chemicalsubstancelist_flg:boolean=false;
    allSelectChemicalSubstance(){
        this.all_chemicalsubstancelist_flg = !this.all_chemicalsubstancelist_flg;
        for(var i in this.chemicalsubstancelist){
            this.chemicalsubstancelist[i]['selected'] = this.all_chemicalsubstancelist_flg;
        }
    }

    all_organicsolventlist_flg:boolean=false;
    allSelectOrganicSolvent(){
        this.all_organicsolventlist_flg = !this.all_organicsolventlist_flg;
        for(var i in this.organicsolventlist){
            this.organicsolventlist[i]['selected'] = this.all_organicsolventlist_flg;
        }
    }

    changeResultOption(event) {
        //0に変更した場合
        if ( event.value == "0" )
        {
            //回答タイプが0の場合は(2→1に変更時)、仮で１をあてる
            if(this.question.m_question_type_id == 0){
                this.question.m_question_type_id = "1";
            }

            if(this.answer_list_info["nextquestionlist"].length==0){
                //２次質問リストが空の時　不可
                this.answer_list_info.nextflg = true;
            }else{
                //２次質問リストが１件以上ある時　可
                this.answer_list_info.nextflg = false;
            }
            return;
        }
        //1に変更した場合
        if ( event.value == "1" )
        {
            //登録されている２次質問は破棄
            for(var i in this.answer_list_info["answerlist"]){
                this.answer_list_info["answerlist"][i]['next_question_list'] = [];
            }
            //対象者選択は単一選択型のみ可能
            if(!( this.question.m_question_type_id == "1" || this.question.m_question_type_id == "3")){
                this.question.m_question_type_id = "1";
            }
            //必ず必須
            this.question.required_flg = true;
            //最終回答は選択出来ない
            this.question.last_text_input_flg = false;
            //２次質問は不可
            this.answer_list_info.nextflg =  true;
            return;
        }
        //2に変更した場合
        if ( event.value == "2" )
        {
            //２次質問は不可
            this.answer_list_info.nextflg =  true;
            return;
        }
    }

    save(mode:number):void{

        this.commonService.modalOpens(50001,
            //保存してもよろしいですか？
            modalresult => {
                if (modalresult == "OK"){
                    //TF→01変換
                    this.question.required_flg = this.commonService.exchangeTFto01(this.question.required_flg);
                    this.question.last_text_input_flg = this.commonService.exchangeTFto01(this.question.last_text_input_flg);
                    this.question.last_text_input_include_flg = this.commonService.exchangeTFto01(this.question.last_text_input_include_flg);
                    this.question.last_text_input_required_flg = this.commonService.exchangeTFto01(this.question.last_text_input_required_flg);

                    //登録タイプが「対象者」の場合
                    if ( this.question.result_option == 1  )
                    {
                        if ( this.question.m_question_type_id== "9"){
                            //過去質問は必須外す
                            this.question.required_flg = 0;
                        }else{
                            //過去質問以外は必須
                            this.question.required_flg = 1;
                        }
                    }

                    //過去質問以外は、過去質問選択はクリア
                    if ( this.question.m_question_type_id!= "9" )
                    {
                        this.question.previous_answer_t_question_category_id = null;
                    }
                    
                    //必須ではない場合、エラーメッセージは登録しない
                    if ( this.question.required_flg == 0 ) { this.question.required_msg = null }
                    if ( this.question.last_text_input_required_flg == 0 ) { this.question.last_text_input_required_msg = null }

                    //対象者選択をクリアし、再設定
                    this.question["target"] = [];
                    if ( this.question.result_option != 1 ) {
                        for(var i in this.targetlist){
                            if ( this.targetlist[i]['selectdata'] == null || this.targetlist[i]['selectdata'] == 'null' )
                            {
                            }else{
                                this.question["target"].push( 
                                    {
                                        "base_question_id": this.targetlist[i]['id'],
                                        "target_id": this.targetlist[i]['selectdata']
                                    }
                                );
                            }
                        }
                    }
                    this.question["target_chemicalsubstance"] = [];
                    if ( this.question.result_option != 1 ) {
                        for(var i in this.chemicalsubstancelist){
                            if ( this.chemicalsubstancelist[i]['selected'])
                            {
                                this.question["target_chemicalsubstance"].push( 
                                    {
                                        "base_question_id": this.chemicalsubstancelist[i]['id'],
                                        "target_id": this.chemicalsubstancelist[i]['m_ksn_grp_id']
                                    }
                                );
                            }
                        }
                    }
                    this.question["target_organicsolvent"] = [];
                    if ( this.question.result_option != 1 ) {
                        for(var i in this.organicsolventlist){
                            if ( this.organicsolventlist[i]['selected'])
                            {
                                this.question["target_organicsolvent"].push( 
                                    {
                                        "base_question_id": this.organicsolventlist[i]['id'],
                                        "target_id": this.organicsolventlist[i]['m_ksn_grp_id']
                                    }
                                );
                            }
                        }
                    }
                    //登録タイプが「タイトル」の場合、タイプ選択は0固定
                    if ( this.question.result_option == 2 )
                    {
                        this.question.m_question_type_id = 0;
                        this.question.required_flg = 0;

                        this.question.last_text_input_flg = 0;
                        this.question.last_text_input_include_flg = 0;
                        this.question.last_text_input_required_flg = 0;
                        this.question.required_msg = null;
                        this.question.last_text_input_required_msg = null;

                        this.answer_list_info["answerlist"] = [];
                    }

                    //登録タイプが「対象者」の場合、設定済の２次質問のリストは空にする
                    if ( this.question.result_option == 1)
                    {
                        for(var i in this.answer_list_info["answerlist"]){
                            this.answer_list_info["answerlist"][i]['next_question_list']=[];
                        }
                    }

                    //選択肢タイプでない場合、のクリア処理
                    if ( this.checkAnswerType(this.question.m_question_type_id)!= 1 )
                    {
                        //最終コメント入力は不可
                        this.question.last_text_input_flg = 0;
                        this.question.last_text_input_include_flg = 0;
                        this.question.last_text_input_required_flg = 0;
                        this.question.last_text_input_required_msg = null;

                        //回答リストは空にする
                        this.answer_list_info["answerlist"]= [];
                    }

                    //セレクトボックスは、最終コメント入力不可
                    if ( this.question.m_question_type_id== "3" )
                    {
                        //最終コメント入力は不可
                        this.question.last_text_input_flg = 0;
                        this.question.last_text_input_include_flg = 0;
                        this.question.last_text_input_required_flg = 0;
                        this.question.last_text_input_required_msg = null;
                    }

                    //回答選択肢が空の場合は削除する
                    this.answer_list_info["answerlist"] = this.answer_list_info["answerlist"].filter(
                        item => 
                        item.answer_text!=null && item.answer_text!=""
                      );

                    for (let i = 0; i < this.answer_list_info["answerlist"].length; i++) {
                        if (this.question['m_question_type_id'] == 6 || this.question['m_question_type_id'] == 7){
                            this.answer_list_info["answerlist"][i]['hidden_flg'] = this.commonService.exchangeTFto01(this.answer_list_info["answerlist"][i]['hidden_flg']);
                        }else{
                            this.answer_list_info["answerlist"][i]['m_substance_id'] = null;
                            this.answer_list_info["answerlist"][i]['hidden_flg'] = 0;
                        }
                    }  
                    if( this.checkAnswerType(this.question.m_question_type_id) == 1){ 
                        this.question.m_answer_type_id = 1;
                        this.question.prefix_label = "";
                        this.question.suffix_label = "";
                    }else if (this.question.m_question_type_id == 10){

                    }else{
                        this.question.m_answer_type_id = 0;
                        this.question.prefix_label = "";
                        this.question.suffix_label = "";
                    }

                    /*■■　パラメータ設定　■■*/
                    let param={
                        language_id: this.selected_language_id,
                        main_language_flg :this.question_caterogy_info.main_language_flg,
                        question_data : this.question,
                        answer_data : this.answer_list_info["answerlist"]
                    };
                    this.questionService.save(param)
                    .subscribe((res: Response) => {
                        if (res["fuel_status"] == "OK") {
                            this.commonService.modalOpens(10001,modalresult=>{
                                if (mode==1){
                                    this.selected_question_id = 0;
                                    this.router.navigate(["/question-register/" + this.selected_question_category_id + '/0/' + this.selected_language_id + '/' + this.question.result_option]);
                                    this.getList();
                                }else{
                                    this.router.navigate(["/question-list/" + this.selected_question_category_id + "/" + this.selected_language_id]);
                                }
                            });
                        }else if (res["fuel_status"] == "NG") {
                            this.commonService.modalOpens(res["fuel_message"],modalresult=>{});
                        }else{
                            this.commonService.modalOpens(11003,modalresult=>{});
                        }
                    },error => {
                        this.commonService.modalOpens(error,modalresult=>{});
                    });
                }else{
                    //
                }
            }
        );
    }

    cancel():void{
        this.commonService.modalOpens(50005,
            //編集中の内容を破棄してもよろしいですか？
                 modalresult => {
                    if (modalresult == "OK"){
                        this.router.navigate(["/question-list/" + this.selected_question_category_id + "/" + this.selected_language_id]);
                    }else{
    
                    }
                }
            );
    }
    checkAnswerType(id:string) : number{
        switch (id){
            //選択肢を入力するもの
            case "1":
            case "2":
            case "3":
            case "6":
            case "7":
                return 1;
            //テキストを入力するもの
            case "4":
            case "5":
            case "8":
            case "10":
                return 2;
            //オプション入力させないもの
            case "9":
                return 3;
            default:
                return 9;
          }
    }
    
    checkAnswerTypeSelect(id:string):boolean{
        if ((this.question.result_option== "1") && !(( id == "1" ) || ( id == "3" ) || ( id == "6" ) || ( id == "7" ) || ( id == "9" ))){
            return true;
        }

        if ((this.question.result_option== "0") && (( id == "6" ) || ( id == "7" ) || ( id == "9" ))){
            return true;
        }
        
        if(this.selected_question_id==0){ //新規追加時
            if(this.question_caterogy_info.type6_exist==1 && id == "6"){
                return true;
            }
            if(this.question_caterogy_info.type7_exist==1 && id == "7"){
                return true;
            }
            if(this.question_caterogy_info.type9_type6_qc_id!=null && this.question_caterogy_info.type9_exist==1 && id == "6"){
                return true;
            }
            if(this.question_caterogy_info.type9_type7_qc_id!=null && this.question_caterogy_info.type9_exist==1 && id == "7"){
                return true;
            }
            if((this.question_caterogy_info.type6_exist==1 && id == "9")&&(this.question_caterogy_info.type7_exist==1 && id == "9")){
                return true;
            }
            if((this.question_caterogy_info.type6_exist==1 ||this.question_caterogy_info.type9_type6_qc_id!=null) && (this.question_caterogy_info.type7_exist==1 || this.question_caterogy_info.type9_type7_qc_id!=null) && id=="9"){
                return true;
            }
        }else{
            if((this.question.result_option== "1") && !(( id == "6" ) || ( id == "7" ) || ( id == "9" ))){ //既存の変更時
                return false;
            }else{
                if(this.question.previous_answer_t_question_category_id!=null){
                    let questoin_type = this.previousspeventlist.filter(
                        item=>
                        item.t_question_category_id == this.question.previous_answer_t_question_category_id
                    );
                    let type = questoin_type[0].m_question_type_ids;
                    if(id=="6" && (this.question_caterogy_info.type9_type6_qc_id!=null || this.question_caterogy_info.type6_exist==1)){
                        if(this.question.m_question_type_id==6){
                            return false;
                        }
                        // if(this.question.m_question_type_id==7 && (this.question_caterogy_info.type9_type6_qc_id!=null || this.question_caterogy_info.type6_exist==1)){
                        //     return false;
                        // }
                        if((this.question.m_question_type_id==1 || this.question.m_question_type_id==3 || this.question.m_question_type_id==9) && (type=="6" || type=="6,7")){
                            return false;
                        }
                        return true;
                    }
                    if(id=="7" && (this.question_caterogy_info.type9_type7_qc_id!=null || this.question_caterogy_info.type7_exist==1)){
                        if(this.question.m_question_type_id==7){
                            return false;
                        }
                        // if(this.question.m_question_type_id==6 && (this.question_caterogy_info.type9_type7_qc_id!=null || this.question_caterogy_info.type7_exist==1)){
                        //     return false;
                        // }
                        if((this.question.m_question_type_id==1 || this.question.m_question_type_id==3 || this.question.m_question_type_id==9) && (type=="7" || type=="6,7")){
                            return false;
                        }
                        return true;
                    }
                    if(id=="9" && (this.question_caterogy_info.type6_exist==1 ||this.question_caterogy_info.type9_type6_qc_id!=null) && (this.question_caterogy_info.type7_exist==1 || this.question_caterogy_info.type9_type7_qc_id!=null)){
                        if(this.question.m_question_type_id!=9){
                            if(this.question.m_question_type_id_old==9){
                                return false;
                            }
                            return true;
                        }else{
                            return false;
                        }
                    }
                }else{
                    if(id=="6" && (this.question_caterogy_info.type9_type6_qc_id!=null || this.question_caterogy_info.type6_exist==1)){
                        if(!(this.question.m_question_type_id==6 || this.question.m_question_type_id_old==6)){
                            if(!(this.question.m_question_type_id==7 && (this.question_caterogy_info.type9_type6_qc_id==null && this.question_caterogy_info.type6_exist==0))){
                                return true;
                            }
                        }
                    }
                    if(id=="7" && (this.question_caterogy_info.type9_type7_qc_id!=null || this.question_caterogy_info.type7_exist==1)){
                        if(!(this.question.m_question_type_id==7 || this.question.m_question_type_id_old==7)){
                            if(!(this.question.m_question_type_id==6 && (this.question_caterogy_info.type9_type7_qc_id==null && this.question_caterogy_info.type7_exist==0))){
                                return true;
                            }
                        }
                    }
                    if(id=="9" && (this.question_caterogy_info.type9_type6_qc_id!=null || this.question_caterogy_info.type6_exist==1) && (this.question_caterogy_info.type9_type7_qc_id!=null || this.question_caterogy_info.type7_exist==1)){
                        if(!((this.question.m_question_type_id==6 || this.question.m_question_type_id_old==6) || (this.question.m_question_type_id==7 || this.question.m_question_type_id_old==7))){
                            return true;
                        }
                    }
                }
            }
            return false;
        }
        return false;
    }
    checkAnswerPreviousspeventlist(id:string):boolean{
        //過去質問リストの制御
        if(this.selected_question_id==0){　//新規追加時
            if((this.question_caterogy_info.type6_exist==1 || this.question_caterogy_info.type9_type6_qc_id!=null) && id=="6"){
                return true;
            }
            if((this.question_caterogy_info.type7_exist==1 || this.question_caterogy_info.type9_type7_qc_id!=null) && id=="7"){
                return true;
            }
            if(((this.question_caterogy_info.type6_exist==1 ||this.question_caterogy_info.type9_type6_qc_id!=null) || (this.question_caterogy_info.type7_exist==1 || this.question_caterogy_info.type9_type7_qc_id!=null)) && id=="6,7"){
                return true;
            }
            return false;
        }else{
            if(this.question.previous_answer_t_question_category_id!=null){ //既存の変更時
                let questoin_type = this.previousspeventlist.filter(
                    item=>
                    item.t_question_category_id == this.question.previous_answer_t_question_category_id
                );
                let type = questoin_type[0].m_question_type_ids;
                if(type!="6,7" && id=="6,7"){
                    return true;
                }
                if(type!="6" && id=="6" && (this.question_caterogy_info.type9_type7_qc_id!=null || this.question_caterogy_info.type7_exist==1)){
                    return true;
                }
                if(type!="7" && id=="7" && (this.question_caterogy_info.type9_type6_qc_id!=null || this.question_caterogy_info.type6_exist==1)){
                    return true;
                }
            }
            if((this.question.m_question_type_id==1 || this.question.m_question_type_id_old==1) || (this.question.m_question_type_id==3 || this.question.m_question_type_id_old==3)){
                if((this.question_caterogy_info.type6_exist==1 || this.question_caterogy_info.type9_type6_qc_id!=null) && (id=="6" || id=="6,7")){
                    return true;
                }
                if((this.question_caterogy_info.type7_exist==1 || this.question_caterogy_info.type9_type7_qc_id!=null) && (id=="7" || id=="6,7")){
                    return true;
                }        
            }
            if((this.question_caterogy_info.type6_exist==1 || this.question_caterogy_info.type9_type6_qc_id!=null) || (this.question_caterogy_info.type7_exist==1 || this.question_caterogy_info.type9_type7_qc_id!=null)){
                if((this.question.m_question_type_id==6 || this.question.m_question_type_id_old==6) && id!="6"){
                    if(this.question_caterogy_info.type7_exist==1 || this.question_caterogy_info.type9_type7_qc_id!=null){
                        return true;
                    }
                }
                if((this.question.m_question_type_id==7 || this.question.m_question_type_id_old==7) && id!="7"){
                    if(this.question_caterogy_info.type6_exist==1 || this.question_caterogy_info.type9_type6_qc_id!=null){
                        return true;
                    }
                }
            }
            return false;       
        }
    }
    checkData():boolean{
        
        //質問内容は必須
        if( this.question.question_text == "" || this.question.question_text == null ){ return true; }

        //タイトルの場合は、ここで終了
        if( this.question.result_option == 2 ){ return false; }

        //対象者選択の場合は、表示名が必須
        if( this.question.result_option == 1  && ( this.question.question_title == "" || this.question.question_title == null ) ){ return true; }
        
        //過去質問参照の場合は、過去質問が必須
        if (this.question.m_question_type_id == "9" && this.question.previous_answer_t_question_category_id == null){ return true; }

        //過去質問参照の場合は、ここで終了
        if (this.question.m_question_type_id == "9"){ return false; }

        //タイプが選択式の場合
        if( this.checkAnswerType(this.question.m_question_type_id) == 1){ 

            //入力されていない回答選択肢が０件だったらNG
            var tempanswerList = this.answer_list_info["answerlist"].filter(
                item => 
                item.answer_text!=null && item.answer_text!=""
              );  
              if ( tempanswerList.length == 0 ){ return true; }

              //回答選択肢のテキストが空なのに、２次質問を持っているもの
              var tempanswerList = this.answer_list_info["answerlist"].filter(
                item => 
                (item.answer_text ==null || item.answer_text=="") && item.next_question_list.length>0
              );  
              if ( tempanswerList.length > 0 ){ return true; }

              //２次質問が空だとNG
            for(var i in this.answer_list_info["answerlist"]){
                var tempNextQuestionList=this.answer_list_info["answerlist"][i]['next_question_list'].filter(
                    item => 
                    item.question_id == null
                  );  
                  if ( tempNextQuestionList.length > 0 ){ return true; }
            }

        }
        //必須フラグがtrueの場合、エラーメッセージが必須
        if (this.question.required_flg && ( this.question.required_msg == "" || this.question.required_msg == null )){ return true; }
        if (this.question.last_text_input_required_flg && ( this.question.last_text_input_required_msg == "" || this.question.last_text_input_required_msg == null )){return true;}

        //２次質問の重複エラーがある場合
        if (this.answer_list_info.errorflg){
            return true;
        }

        return false;
    }
}



// WEBPACK FOOTER //
// ./src/app/a0103-question-register/question-register.component.ts